export const tagNameRegex= /^[a-z][0-9a-z]*(_[0-9a-z]+)*$/


const isValidTagName = (tagName) => {
  if (!tagName) return false;
  if (tagName.length < 2 || tagName.length > 20) return false;
  return tagNameRegex.test(tagName);
}

export default isValidTagName;